// import {testURL} from '../url/index'
import request from '@/util/request'

export function zr (timeRange) {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/calWorkHours/zr',
    method: 'post',
    data: timeRange
  })
}
export function zrv2 (data) {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/calWorkHours/zrv2',
    method: 'post',
    data: data
  })
}
export function zrv3 (data) {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/calWorkHours/zrv3',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/calWorkHours.js